import { html, nothing } from 'lit';
import { PurposeType } from '@common/types/enum.js';
import type { Purpose } from '@common/types/model.d.js';
import type { TefComs4p } from '@src/components/TefComs4p.js';

export const renderSinglePurposeConsents = (component: TefComs4p, purpose: Purpose) => {
  let subscriptionsHtml = [html`${nothing}`];

  if (purpose.purposeType === PurposeType.identifier_bound && purpose.subscriptions) {
    subscriptionsHtml = purpose.subscriptions.map((subscription) => component.getTemplateFn('singleSubscriptionIdentifierBoundEdit')(subscription));
  } else if (purpose.purposeType === PurposeType.user_bound) {
    subscriptionsHtml = [component.getTemplateFn('singlePurposeUserBoundEdit')(purpose)];
  }

  return subscriptionsHtml;
};

//
// renders a single purpose block
//
// {Purpose name}
// {Purpose description}
//   {subscription BLOCK}
export const singlePurposeEdit = function render(this: TefComs4p, purpose : Purpose) {
  return html`
    <h5 class="divider--size-flat">${purpose.title}</h5>
    <p>
      ${purpose.shortDescription}
      ${this.getTemplateFn('tefPurposeDescriptionModal')(purpose)}
    </p>
    ${renderSinglePurposeConsents(this, purpose)}
  `;
};
